import { Button, Typography } from '@breetometer/components';
import { CautionIcon } from 'BreetAssets';
import { useModalApi } from 'BreetHooks';

export const DialogTwoFaSecurityPolicy = () => {
	const { handleModalClose } = useModalApi();

	return (
		<div className='two-fa-warning bg-primary-500'>
			<CautionIcon />

			<Typography
				as='h4'
				className='color-neutral-50'
			>
				Security Policy
			</Typography>

			<Typography className='color-primary-100'>
				For security reasons, at least one authenticator method must remain enabled at all times.
			</Typography>

			<Button onClick={handleModalClose('twoFASecurityPolicy')}>Okay</Button>
		</div>
	);
};
